<template>
    <div v-if="allSelfCollections">
        <div class="is-flex is-align-items-center is-justify-content-space-between mb-3">
            <h1 class="title is-5 mb-0">Total Self Collections: {{ allSelfCollections.length }}</h1>
            <div class="field has-addons mb-0">
                <p class="control">
                    <button class="button is-small" :class="{ 'is-link': sortBy === 'beneficiary_id' }"
                        @click="sortBy = 'beneficiary_id'">ID</button>
                </p>
                <p class="control">
                    <button class="button is-small" :class="{ 'is-link': sortBy === 'completed_at_time' }"
                        @click="sortBy = 'completed_at_time'">Completed Time</button>
                </p>
            </div>
        </div>
        <DeliveryItem v-for="delivery in sortedSelfCollections" :key="delivery.beneficiary_id" :name="delivery.full_name"
            :dryBag="delivery.dry_bag" :quantity="delivery.quantity" :unit="delivery.unit" :block="delivery.block"
            :street="delivery.street" :completed="delivery.completed" :completedAtTime="delivery.completed_at_time"
            :age="delivery.age" :deliverySort="delivery.delivery_sort" :beneficiaryID="delivery.beneficiary_id"
            :fdID="this.fdID" :fdStatus="this.fdStatus" :status="delivery.status"
            :selfCollection="delivery.self_collection" :drivingDelivery="delivery.driving_delivery" :deliveryNotes="delivery.notes"
            :drivingTeams="this.drivingTeams" :walkingTeams="this.walkingTeams"  :consecutiveUndeliveredCount="delivery.consecutive_undelivered_count"
            :dietaryRequirement="delivery.dietary_requirement" :adminNotes="delivery.delivery_notes">
        </DeliveryItem>
    </div>
</template>

<script>
import DeliveryItem from './DeliveryItem.vue';
export default {
    components: {
        DeliveryItem
    },
    props: ['fdID', 'fdStatus', 'drivingTeams', 'walkingTeams'],
    data() {
        return {
            sortBy: 'beneficiary_id'
        };
    },
    computed: {
        allSelfCollections() {
            return this.$store.getters['delivery/getSelfCollections'];
        },
        sortedSelfCollections() {
            if (!this.allSelfCollections) return [];
            const list = [...this.allSelfCollections];
            if (this.sortBy === 'completed_at_time') {
                return list.sort((a, b) => {
                    const ta = a.completed_at_time ? a.completed_at_time.toMillis?.() ?? a.completed_at_time : null;
                    const tb = b.completed_at_time ? b.completed_at_time.toMillis?.() ?? b.completed_at_time : null;
                    if (ta === null && tb === null) return 0;
                    if (ta === null) return 1;
                    if (tb === null) return -1;
                    return ta - tb;
                });
            }
            return list.sort((a, b) => a.beneficiary_id - b.beneficiary_id);
        }
    }
}
</script>